<script setup>
import { ref, watch } from 'vue'

// Define component props
const properties = defineProps({
  header: {
    type: String,
    default: null, // Title content of the dialog
  },
  footer: {
    type: String,
    default: null, // Footer content of the dialog
  },
  visible: {
    type: Boolean,
    required: true, // Visibility bound via v-model:visible
  },
  modal: {
    type: Boolean,
    default: true, // Whether the dialog is modal or not
  },
  closable: {
    type: Boolean,
    default: true, // Show times icon to close
  },
  draggable: {
    type: Boolean,
    default: false, // Disable default draggable behavior
  },
  pt: {
    type: Object,
    default: () => {},
  },
})

// Emits for v-model:visible
const emit = defineEmits(['update:visible'])

// Local state to track dialog visibility
const isVisible = ref(properties.visible)

// Watch prop and sync local state when it changes
watch(
  () => properties.visible,
  (newValue) => {
    isVisible.value = newValue
  },
)

// Function to emit the update to visibility (triggered when dialog closes)
function closeDialog() {
  emit('update:visible', false) // Emit to parent to set visible to false
}
</script>

<template>
  <Dialog
    v-model:visible="isVisible"
    :modal="modal"
    :header="header"
    :closable="closable"
    :draggable="draggable"
    :pt="pt"
    @hide="closeDialog"
  >
    <!-- Default slot for dialog content -->
    <slot />

    <!-- Custom footer slot or fallback to footer prop -->
    <template
      v-if="$slots.footer"
      #footer
    >
      <slot name="footer" />
    </template>
  </Dialog>
</template>
